import { browser, device, os } from '@/utils/detect'

function setBodyClasses(phase = 1) {
  const classes = [
    device.mobile ? 'mobile-device' : '',
    device.touch ? 'touch-device' : '',
    device.type,
    browser.name,
    os.name,
    `phase-${phase}`
  ].filter(Boolean)
  classes.forEach((c) => document.body.classList.add(c.toLowerCase().split(' ').join('-')))
}

export default setBodyClasses
